import { SeuilsApi } from "../../utils/api";

export const dateValues = [
    { label: 'Jan', value: '1', id: 'date-jan', showed: 'Janvier' },
    { label: 'Fev', value: '2', id: 'date-fev', showed: 'Février' },
    { label: 'Mar', value: '3', id: 'date-mar', showed: 'Mars' },
    { label: 'Avr', value: '4', id: 'date-avr', showed: 'Avril' },
    { label: 'Mai', value: '5', id: 'date-mai', showed: 'Mai' },
    { label: 'Juin', value: '6', id: 'date-juin', showed: 'Juin' },
    { label: 'Juil', value: '7', id: 'date-juil', showed: 'Juillet' },
    { label: 'Aoû', value: '8', id: 'date-aou', showed: 'Août' },
    { label: 'Sep', value: '9', id: 'date-sep', showed: 'Septembre' },
    { label: 'Oct', value: '10', id: 'date-oct', showed: 'Octobre' },
    { label: 'Nov', value: '11', id: 'date-nov', showed: 'Novembre' },
    { label: 'Dec', value: '12', id: 'date-dec', showed: 'Décembre' },
  ];
export const makeAsDate = (value: number) => {
    let date;
    dateValues.forEach((elem) => {
      if (parseInt(elem.value) === value) {
        date = elem;
      }
    });
    return date;
  };
// create row data function
export function createData(arr: any) {
    return arr
      .filter((p: any) => p.id !== undefined)
      .map((p: any) => ({ id: p.id, name: p.variableName, value: p.value, date: p.date, source: p.source }));
  }
// columns table pumps list
export const columns = [
    { id: 'source', label: 'Source', minWidth: 170 },
    { id: 'pompe', label: 'Pompe', minWidth: 170 },
    { id: 'date', label: 'Date de la mesure', minWidth: 170 },
    { id: 'Débit', label: 'Débit (m³/h)', minWidth: 170 },
  ];
  
  // handle table pump Delete function
  export const handleDelete = async (pumpId: number, props: any) => {
    props.setLoading(true);
    try {
      const response = await SeuilsApi.deletePumpParameter(pumpId);
  
      if (response.status === 200) {
        const response = await SeuilsApi.getPumpParameters(props.mainInstallCode);
        props.setPumps([
          ...response.data.pumpsToConfigureList,
          ...response.data.configuredPumpsList,
        ]);
      }
    } catch (e) {
      console.log(e);
    }
    props.setLoading(false);
  };